import { $getQueryParams , $handleError} from '@/utils';
import httpService from '@Utils/httpService';
const baseUrl = 'api/documents';

export default {
  get(params) {
    const qParams = $getQueryParams(params);

    return httpService.get({
      url: baseUrl + '?' + qParams.toString(),
    });
  },
   typeHead(params) {
  

    return httpService.get({
      url: baseUrl+'/typeHead/simple',
      params
    });
  },
  getByTaskId(params) {
    const qParams = $getQueryParams(params);

    return httpService.get({
      url: baseUrl + `/taskId/${params.taskId}?` + qParams.toString(),
    });
  },
  getByTagId(tagId,params) {
    const qParams = $getQueryParams(params);

    return httpService.get({
      url: baseUrl + `/tagId/${tagId}?` + qParams.toString(),
    });
  },
  // AVA-437 Tier 2 — documents linked to a specific CML (and optionally a TmlPoint) via
  // markup links. params: { tmlPointId?, AssetId }. Returns a flat DocumentVM list.
  getByCmlId(cmlId, params) {
    const qParams = $getQueryParams(params);

    return httpService.get({
      url: baseUrl + `/CmlId/${cmlId}?` + qParams.toString(),
    });
  },
  getById(id) {
    return httpService.get({
      url: `${baseUrl}/${id}`,
    });
  },
  update(data) {
    if (!data.id) return this.add(data);
    return httpService.put({
      url: `${baseUrl}/${data.id}`,
      data,
    });
  },
  
  add(data) {
    
    return httpService.post({
      url: baseUrl+`/AddDocuments`,
      data,
    });
  },
  /** @param {Object} [config] extra request options, e.g. `{ critical: true }` for background uploads */
  addRevision(data, config = {}) {
    return httpService.post({
      ...config,
      url: baseUrl+`/${data.documentId}/Revision`,
      data,
    });
  },

  addOrUpdate(data, isNew) {
    if (isNew)
      return httpService.post({
        url: baseUrl,
        data,
      });
    else {
      return httpService.put({
        url: `${baseUrl}/${data.id}`,
        data,
      });
    }
  },
   matchByName(documentList) {
  return httpService.post({
        url: `${baseUrl}/match`,
        data:documentList,
      });
  },

  del(id) {
    return httpService.delete({
      url: `${baseUrl}/${id}`,
    });
  },
  upload(files){
    let formData = new FormData();

    files.forEach(file => {
        formData.append("files", file);
    });

    return httpService.post({
        url: `${baseUrl}/uploadFiles`,
        data: formData,
    }).then((response) => {
        return response.data;
    }).catch((error) => {
        $handleError(error);
        return [];
    });
  }
};
